import { Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from '../localization/translation-loader.facade';


@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {

  constructor(private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
